module.exports = __webpack_public_path__ + "static/undraw_outdoor-01cf364619dcd1408f9d56f91b114861.svg";